import { WroColumnNamesEnum } from '@/enums/modules/receiving'

export const FIELD_MAP = {
  Id: 'id',
  PurchaseOrderNumber: 'purchaseOrderNumber',
  CreationDate: 'insertDate',
  FulfillmentCenter: 'fulfillmentCenter',
  WroSummary: 'wroSummary',
  ReturnId: 'returnId',
  Status: 'status'
}

export default [
  { name: WroColumnNamesEnum.Id, field: FIELD_MAP.Id },
  { name: WroColumnNamesEnum.PurchaseOrderNumber, field: FIELD_MAP.PurchaseOrderNumber },
  { name: WroColumnNamesEnum.CreationDate, field: FIELD_MAP.CreationDate },
  { name: WroColumnNamesEnum.FulfillmentCenter, field: FIELD_MAP.FulfillmentCenter },
  { name: WroColumnNamesEnum.WroSummary, field: FIELD_MAP.WroSummary },
  { name: WroColumnNamesEnum.Status, field: FIELD_MAP.Status }
]
